const D = "https://manage.rackspace.com", U = "https://dev.manage.rackspace.com", it = "https://local.dev.manage.rackspace.com", R = {
  LOCAL: "__janus_login_csurf_dev_subdomain__",
  DEV: "__janus_login_csurf_dev__",
  PROD: "__janus_login_csurf_prod__"
}, $ = "https://proxy.api.manage.rackspace.com/customer-admin/";
var y = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(e, t) {
  (function(n) {
    var o;
    if (e.exports = n(), o = !0, !o) {
      var r = window.Cookies, i = window.Cookies = n();
      i.noConflict = function() {
        return window.Cookies = r, i;
      };
    }
  })(function() {
    function n() {
      for (var i = 0, s = {}; i < arguments.length; i++) {
        var a = arguments[i];
        for (var l in a)
          s[l] = a[l];
      }
      return s;
    }
    function o(i) {
      return i.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function r(i) {
      function s() {
      }
      function a(c, d, u) {
        if (!(typeof document > "u")) {
          u = n({
            path: "/"
          }, s.defaults, u), typeof u.expires == "number" && (u.expires = new Date(new Date() * 1 + u.expires * 864e5)), u.expires = u.expires ? u.expires.toUTCString() : "";
          try {
            var C = JSON.stringify(d);
            /^[\{\[]/.test(C) && (d = C);
          } catch {
          }
          d = i.write ? i.write(d, c) : encodeURIComponent(String(d)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), c = encodeURIComponent(String(c)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var m = "";
          for (var f in u)
            !u[f] || (m += "; " + f, u[f] !== !0 && (m += "=" + u[f].split(";")[0]));
          return document.cookie = c + "=" + d + m;
        }
      }
      function l(c, d) {
        if (!(typeof document > "u")) {
          for (var u = {}, C = document.cookie ? document.cookie.split("; ") : [], m = 0; m < C.length; m++) {
            var f = C[m].split("="), p = f.slice(1).join("=");
            !d && p.charAt(0) === '"' && (p = p.slice(1, -1));
            try {
              var k = o(f[0]);
              if (p = (i.read || i)(p, k) || o(p), d)
                try {
                  p = JSON.parse(p);
                } catch {
                }
              if (u[k] = p, c === k)
                break;
            } catch {
            }
          }
          return c ? u[c] : u;
        }
      }
      return s.set = a, s.get = function(c) {
        return l(c, !1);
      }, s.getJSON = function(c) {
        return l(c, !0);
      }, s.remove = function(c, d) {
        a(c, "", n(d, {
          expires: -1
        }));
      }, s.defaults = {}, s.withConverter = r, s;
    }
    return r(function() {
    });
  });
})(y);
const F = y.exports, A = (e, t) => Object.fromEntries(Object.entries(e).filter(([n]) => !t.includes(n))), j = (e, t = []) => {
  const n = {};
  return t.forEach((o) => {
    n[o] = e[o];
  }), n;
}, w = (e = "") => new RegExp(`/local.${e}`).test(window.location.origin), L = () => /\/dev\.manage\./.test(window.location.origin), T = () => /\/manage\./.test(window.location.origin), v = (e) => typeof e > "u" ? `${window.location.pathname}/`.includes("/racker/") : e, I = () => w("dev") ? U : w("prod") ? D : window.location.origin, M = (e = {}) => {
  const t = Object.keys(e);
  return t.length === 0 ? "" : "?" + t.map((n) => `${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`).join("&");
}, h = (e) => {
  const t = I(), o = v(e) ? "r" : "c";
  return {
    base: () => t,
    proxyTo: (r) => (r.startsWith("http") || console.warn(`fabric-session-ui: url (${r}) does not start with "http" is it valid?`), `${t}/ui-proxy/${o}/${encodeURIComponent(r)}`),
    login: (r = window.location.href) => `${t}/login/${o}?RelayState=${r}`,
    session: () => `${t}/login/${o}/session`,
    sessionActivity: () => `${t}/login/${o}/session-activity`,
    staticPilot: (r = "default") => `https://dlp3xg0a726x4.cloudfront.net/default-headers/${r}.html`,
    pilot: (r) => `https://${S().pilotTest ? "test.pilot.manage.rackspace.com" : "pilot.manage.rackspace.com"}/v1/cloud/:rackspaceAccountNumber/navigation${M(r)}`,
    pilotRacker: () => `https://${S().pilotTest ? "test.pilot.manage.rackspace.com" : "pilot.manage.rackspace.com"}/v1/racker/navigation`,
    rackerDashboard: () => `${t}/dashboard/racker/search`
  };
}, H = () => w() ? R.LOCAL : L() ? R.DEV : (T(), R.PROD), B = (e) => e || (w() ? "include" : "same-origin"), G = "fabric-session-ui", J = (e) => e || window.location.pathname.split("/")[1] || G, V = (e, t) => {
  let n = 0;
  return function() {
    const r = new Date().getTime();
    r - n >= t && (e(), n = r);
  };
}, st = () => {
  if (T())
    return { shortName: "prod", name: "production" };
  if (w())
    return { shortName: "local", name: "local" };
  if (L())
    return { shortName: "dev", name: "development" };
}, W = (e = "") => ({
  isDedicated: e.startsWith("dedicated:"),
  rackspaceAccountNumber: String(e).replace("dedicated:", "")
}), S = () => {
  var e;
  return {
    pilotTest: /pilotTest/i.test((e = window.location) == null ? void 0 : e.search)
  };
}, K = () => new Promise(() => {
}), X = (e = [], t) => (n) => {
  if (e.includes(n.status)) {
    const o = h(t).login();
    return window.location.replace(o), console.error(`fabric-ui-session: initiating re-authentication on ${n.status} status code`), K();
  }
  return Promise.resolve(n);
}, q = (e) => (t) => {
  const n = () => window.location.replace(h(e).login());
  return t.status === 403 ? t.clone().text().then((r) => {
    const i = (s) => {
      var a;
      return ((a = s == null ? void 0 : s.error) == null ? void 0 : a.message) === "invalid csrf token";
    };
    try {
      if (i(JSON.parse(r)))
        return n(), Promise.reject(new z("CSRF Token is invalid, initiating re-authentication..."));
    } catch {
    }
    return t;
  }) : Promise.resolve(t);
};
class z extends Error {
  constructor(t) {
    super(t), this.name = "InvalidCSRFTokenError";
  }
}
const Q = (e = H()) => {
  const t = F.get(e), n = typeof process < "u" && typeof process.version < "u";
  return !t && !n && console.warn("fabric-ui-session: No CSRF cookie value is present, this can cause requests to fail"), e && t ? { "X-Csrf-Token": t } : {};
}, Z = (e, t) => {
  const { headers: n, ...o } = e, { appName: r } = t, i = (s) => {
    if (s instanceof window.Headers) {
      const a = {};
      return s.forEach((l, c) => {
        a[c] = l;
      }), a;
    }
    return s;
  };
  return {
    credentials: B(e.credentials),
    method: "GET",
    headers: {
      ...Q(),
      "User-Agent": J(r),
      Accept: "application/json",
      "Content-Type": "application/json",
      ...i(n) || {}
    },
    ...o
  };
}, E = [
  "racker",
  "cookieNameCSRF",
  "authenticateOnStatusCodes",
  "appName",
  "bypassProxy"
], Y = (e, t = {}) => {
  const n = A(t, E), o = j(t, E), { racker: r } = o, i = v(r);
  return [o.bypassProxy ? e : h(i).proxyTo(e), Z(n, o)];
}, g = (e, t = {}) => {
  const { racker: n, authenticateOnStatusCodes: o = [] } = t, r = v(n);
  return fetch(...Y(e, t)).then(X(o, r)).then(q(r));
}, ct = (e = {}) => {
  const t = h(v(e.racker)).session();
  return g(t, {
    ...e,
    bypassProxy: !0,
    authenticateOnStatusCodes: e.authenticateOnStatusCodes || [401, 403]
  }).then((n) => n.json());
}, x = (e, t) => (n) => {
  const o = t ? "pilotRackerNavLoaded" : "pilotGlobalNavLoaded";
  return new Promise((r, i) => {
    if (!e instanceof Node)
      return i(new Error("ProgrammingError: A valid DOM element must be provided in order to load and mount Pilot"));
    window.document.addEventListener(o, () => {
      r(window.pilot);
    }, { once: !0 }), e.hasChildNodes() ? e.innerHTML = n : e.appendChild(document.createRange().createContextualFragment(n));
  });
}, tt = (e, t) => g(h().staticPilot(t), {
  method: "GET",
  headers: {
    "Context-Type": "text/html",
    Accept: "text/html"
  }
}).then((n) => n.text()).then(x(e)), et = (e, t = {}, n = {}) => {
  var r, i;
  const o = {
    "primary-nav": { show: (i = (r = t["primary-nav"]) == null ? void 0 : r.show) != null ? i : !1 },
    logout: { uri: "/logout/c" }
  };
  return g(h().pilot(n), {
    method: "POST",
    body: JSON.stringify(o),
    headers: {
      "Context-Type": "text/html",
      Accept: "text/html"
    }
  }).then((s) => {
    if (s.status !== 200)
      throw new Error("Global nav returned with non-200 response, skipping pilot render");
    return s;
  }).then((s) => s.text()).then(x(e));
}, at = (e, t, n, o) => Promise.race([
  et(e, t, n),
  new Promise((r, i) => setTimeout(i, 5e3))
]).catch((r) => (console.error("fabric-ui-session: failed to load Pilot, ", r), tt(e, o))), P = (e) => {
  const { isDedicated: t, rackspaceAccountNumber: n } = W(e);
  return g(`${$}/v3/customer_accounts/${t ? "MANAGED_HOSTING" : "CLOUD"}/${n}`).then((o) => {
    if (!o.ok)
      throw new Error("could not fetch customer account to set pilot context");
    return o.json();
  });
}, N = {
  autoCustomerContextResolution: !0,
  domainFromURLRegex: /(.*\/racker\/?)([a-z:0-9]+|$)(.*|$)/i,
  keepSubPaths: !1,
  changeLocation: (e) => {
    window.location.replace(e);
  },
  changeLocationRemote: (e) => {
    window.location.replace(e);
  },
  onCustomerContextChange: () => {
  },
  fetchCMSAccount: P
}, nt = (e = "", t = "/") => e.charAt(e.length - 1) === t ? e : `${e}${t}`, O = (e = "", t, n) => {
  const o = (r, i, s, a) => (n.keepSubPaths || (a = ""), [
    nt(i, "/"),
    t,
    a,
    window.location.search
  ].join(""));
  return e.replace(n.domainFromURLRegex, o);
}, _ = (e) => {
  var t, n;
  return (n = (t = e.domainFromURLRegex.exec(window.location.pathname)) == null ? void 0 : t[2]) != null ? n : "";
}, ot = "CustomerContextEvent", rt = (e = {}) => (t) => {
  var i, s;
  const n = { ...N, ...e };
  if (!n.autoCustomerContextResolution)
    return Promise.resolve(t);
  window.document.addEventListener(ot, (a = {}) => {
    const l = O(window.location.pathname, t.getCustomer().domain, n);
    let c = !1;
    n.onCustomerContextChange({
      fabricUISessionConfig: n,
      ...a,
      pilot: t,
      redirectTo: l,
      preventDefault: () => c = !0
    }), !c && t.getCustomer().domain !== _(n) && n.changeLocation(l);
  }, { passive: !0 });
  const o = (i = _(n)) != null ? i : "", r = (s = t.getCustomer().domain) != null ? s : "";
  if (o === r)
    !r && !o && n.changeLocationRemote(h().rackerDashboard());
  else if (!o && r)
    n.changeLocation(O(window.location.pathname, r, n));
  else if (o && o !== r)
    return P(o).then((a) => (t.setCustomer(a.name, o), t)).catch(() => (console.error("fabric-ui-session: could find find valid customer context from URL, unsetting pilot customer context"), t.setCustomer(), t));
  return Promise.resolve(t);
}, ut = (e, t = {}) => {
  var n;
  return g(h().pilotRacker(), {
    method: "POST",
    body: JSON.stringify(A(t, Object.keys(N))),
    headers: {
      "Context-Type": "application/json"
    },
    racker: !0,
    authenticateOnStatusCodes: (n = t == null ? void 0 : t.authenticateOnStatusCodes) != null ? n : [403, 401]
  }).then((o) => {
    if (o.status !== 200)
      throw new Error("Racker Global nav returned with non-200 response, skipping pilot render");
    return o;
  }).then((o) => o.text()).then(x(e, !0)).then(rt(t));
};
class dt {
  constructor({ racker: t, authenticateOnStatusCodes: n = [401] } = {}) {
    this.subscriptions = [], this.isRacker = v(t), this.authenticateOnStatusCodes = n, this.duration = 30 * 1e3, this.throttledNotification = V(this.callKeepAliveEndpoint.bind(this), this.duration), this.lastActivity = Date.now();
  }
  subscribe(t) {
    this.subscriptions.push(t);
  }
  unsubscribe(t) {
    this.subscriptions = this.subscriptions.filter((n) => n === t);
  }
  callKeepAliveEndpoint() {
    const t = h(this.isRacker).sessionActivity();
    return g(t, {
      bypassProxy: !0,
      racker: this.isRacker,
      authenticateOnStatusCodes: this.authenticateOnStatusCodes
    }).then((n, o) => (this.lastActivity = Date.now(), this.subscriptions.forEach((r) => r(n.ok, o)), n)).catch((n) => {
    });
  }
  run() {
    document.addEventListener("click", this.throttledNotification), document.addEventListener("keyup", this.throttledNotification), document.addEventListener("scroll", this.throttledNotification);
  }
  cleanup() {
    document.removeEventListener("click", this.throttledNotification), document.removeEventListener("keyup", this.throttledNotification), document.removeEventListener("scroll", this.throttledNotification);
  }
}
export {
  dt as ActivityNotifier,
  U as DEV_BASE_URL,
  z as InvalidCSRFTokenError,
  it as LOCAL_BASE_URL,
  D as PROD_BASE_URL,
  x as addPilotHTMLTo,
  q as authenticateOnBadCSRFToken,
  X as authenticateOnStatus,
  st as getEnvironment,
  Y as getProxyFetchArgs,
  ct as getSession,
  h as getURLS,
  L as isDev,
  w as isLocal,
  T as isProd,
  v as isRacker,
  at as loadPilot,
  ut as loadRackerPilot,
  rt as negotiateCustomerContext,
  g as proxyFetch,
  W as unpackDomainId
};
